/**
 * Pre-footer video card scales in as it enters view; its heading/CTA
 * follow a beat behind, matching the footer-column stagger treatment.
 */
import { revealOnScroll } from '@theme/premium-motion';

revealOnScroll('.flv-prefooter__card', { y: 0, scale: 1.06, duration: 1.1 });
revealOnScroll('.flv-prefooter__content', { y: 24, scale: 1, duration: 0.8, delay: 0.15 });
